export function headerBundle(container) {
  document.querySelector(`.header__desktop__bar__c .header__menu`).classList.add('header__menu--bundle');

  let step1Class = '';
  let step2Class = '';
  let step3Class = '';


  if( location.pathname.indexOf( `infant-lounger-` ) !== -1 ) {
    step1Class = 'completed';
  }
  if( location.pathname.indexOf( `toddler-lounger-` ) !== -1 ) {
    step1Class = 'completed';
  }
  if( location.pathname.indexOf( `infant-lounger-cover-` ) !== -1 ) {
    step1Class = 'completed';
    step2Class = 'completed';
  }
  if( location.pathname.indexOf( `toddler-lounger-cover-` ) !== -1 ) {
    step1Class = 'completed';
    step2Class = 'completed';
  }

  if( window.location.search.indexOf(`step=complete`) !== -1 || window.location.href.indexOf(`/cart?view=bundle`) !== -1 ) {
    step1Class = 'completed';
    step2Class = 'completed';
    step3Class = 'completed';
  }

  const stepHtml = `
    <div class="menu__item child ${step1Class}" data-main-menu-text-item data-step="lounger">
      <a href="#" data-top-link class="navlink navlink--toplevel">
        <span class="navstep"><span>1</span></span>
        <span class="navtext">${theme.strings.product.nav.lounger}</span>
      </a>
    </div>
    <div class="menu__item child ${step2Class}" data-main-menu-text-item data-step="covers">
      <a href="#" data-top-link class="navlink navlink--toplevel">
        <span class="navstep"><span>2</span></span>
        <span class="navtext">${theme.strings.product.nav.covers}</span>
      </a>
    </div>
    <div class="menu__item child ${step3Class}" data-main-menu-text-item data-step="complete">
      <a href="#" data-top-link class="navlink navlink--toplevel">
        <span class="navstep"><span>3</span></span>
        <span class="navtext">
          <span class="small-down--hide">${theme.strings.product.nav.complete}</span>
          <span class="medium-up--hide">${theme.strings.product.nav.completeMobile}</span>
        </span>
      </a>
    </div>
  `;

  document.querySelector(`.header__desktop__bar__c .header__menu__inner`).innerHTML = stepHtml;

  document.querySelectorAll(`[bundle-progress-bar-mobile]`).forEach((element) => {
    element.innerHTML = `
      <div class="bundle-progress-bar--mobile text-center">
        <div class="header__menu header__menu--bundle" style="display:inline-block;">
          <div class="header__menu__inner">
            ${stepHtml}
          </div>
        </div>
      </div>
    `;
  });


  const exitHtml = `
    <div class="header__desktop__buttons header__desktop__buttons--icons header__desktop__buttons--bundle">
      <div class="header__desktop__button">
        <a href="/" class="navlink" data-popdown-toggle="search-popdown" aria-haspopup="true" aria-expanded="false" aria-controls="search-popdown">
          <span class="navtext">${theme.strings.product.nav.exit}</span>
          <span class="navicon">
            <svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" viewBox="0 0 15 15"><g fill-rule="evenodd"><path d="M2.06 1l12.02 12.021-1.06 1.061L1 2.062z"></path><path d="M1 13.02L13.022 1l1.061 1.06-12.02 12.02z"></path></g></svg>
          </span>
        </a>
      </div>
    </div>
  `;
  document.querySelector(`.header__desktop__bar__r`).innerHTML = exitHtml;
}
